/**
 * Created by vtbelo on 09.08.2022
 */

cc.ScrollAction = function (targetNode, params) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._params = params || {};

    let duration = this._params.duration === undefined ? cc.ScrollAction.SCROLL_TO_DURATION : this._params.duration;
    if (this._params.silent) {
        duration = 0;
    }

    this._creationStack = new Error().stack;

    this._targetNode = targetNode;

    cc.ActionInterval.prototype.initWithDuration.call(this, duration);
};

cc.ScrollAction.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.ScrollAction,

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);

        this._startPosition = this.target.getContainerPosition();

        if (target.isMapScroll && cleverapps.focusManager.isFocused() && !this._params.allowScrollWithFocus && typeof Map2dLocation !== "undefined" && !Map2dLocation.currentLocation.tutorial.isActive() && !cleverapps.tutorial.isActive()) {
            if (!this._params.skipFocusReport) {
                cleverapps.throwAsync(`Trying to scroll with focus, stack - ${this._creationStack}`);
            }

            return;
        }

        if ((this._targetNode instanceof cc.Node) && !this._targetNode.isRunning()) {
            return;
        }

        target.stopAutoScroll();
        target.setScrollAction(this);

        if (typeof this._targetNode === "number") {
            this._targetPosition = this.target.normalizePoint(this.target.outOfBoundariesVector(this._targetNode, this._params.padding));
        } else if (!this._targetNode || typeof this._targetNode === "object" && this._targetNode.stopListeners) {
            this._targetPosition = this._startPosition;
        } else if (this._params.targetPoint) {
            this._targetPosition = this._targetNode;
        } else if (this._params.visibleBox) {
            const delta = this.calcNodeDelta(this.target, this._targetNode, this._params);
            this._targetPosition = cc.pAdd(this._startPosition, delta);
        } else {
            this._targetPosition = this.target.normalizePoint(this.target.outOfBoundariesVector(this._targetNode, this._params.padding));
        }
    },

    update: function (time) {
        if (!this.target || !this._startPosition || !this._targetPosition) {
            return;
        }

        time = this._computeEaseTime(time);
        this.target.scrollToPoint(cc.pAdd(this._startPosition, cc.pMult(cc.pSub(this._targetPosition, this._startPosition), time)));
    },

    calcNodeDelta: function (scrollView, target, options) {
        const visibleBox = {
            left: 1,
            right: 1,
            top: 1,
            bottom: 1,
            ...options.visibleBox
        };

        const oldZoom = scrollView.zoom;
        if (scrollView.zoomHandler && options.zoom) {
            scrollView.zoomHandler.setZoom(options.zoom, true);
        }

        const box = target.getBoundingBox();

        let bottomLeft = cc.p(box.x, box.y);
        let topRight = cc.p(box.x + box.width, box.y + box.height);

        bottomLeft = scrollView.centerNode.convertToNodeSpace(target.getParent().convertToWorldSpace(bottomLeft));
        topRight = scrollView.centerNode.convertToNodeSpace(target.getParent().convertToWorldSpace(topRight));

        const s = scrollView.centerNode.getScale();
        const visibleBottomLeft = cc.p(-scrollView.width / s / 2 * visibleBox.left, -scrollView.height / s / 2 * visibleBox.bottom);
        const visibleTopRight = cc.p(scrollView.width / s / 2 * visibleBox.right, scrollView.height / s / 2 * visibleBox.top);

        let delta = cc.p(0, 0);
        if (bottomLeft.x < visibleBottomLeft.x) {
            delta.x = -(visibleBottomLeft.x - bottomLeft.x);
        }
        if (topRight.x > visibleTopRight.x) {
            delta.x = topRight.x - visibleTopRight.x;
        }

        if (bottomLeft.y < visibleBottomLeft.y) {
            delta.y = -(visibleBottomLeft.y - bottomLeft.y);
        }
        if (topRight.y > visibleTopRight.y) {
            delta.y = topRight.y - visibleTopRight.y;
        }

        delta = cc.pAdd(delta, scrollView.scrollHandler.getHowMuchOutOfBoundary(delta));

        if (scrollView.zoomHandler && options.zoom) {
            scrollView.zoomHandler.setZoom(oldZoom, true);
        }

        return delta;
    }
});

cc.ScrollAction.SCROLL_TO_DURATION = 1;